<template>
	<div class="p-selectbutton">
		<Button @click="toggleColorPicker">
			<span class="material-symbols-outlined" :style="selectedColor"> {{ colorOptions.icon }}</span>
		</Button>
	</div>

	<OverlayPanel ref="colorMenu">
		<div class="d-flex p-0">
			<div style="font-size: smaller;">
				<table class="colorMenu">
					<tr>
						<td v-for="(index) in colorMenuItem.colors.length" :key="index" style="padding: 0px 2px 6px 0px;">
							<div :style="'background-color: var(--' + colorMenuItem.monochrome + '-' + (900 - (index * 100)) + ')'" @click="selectColor('--' + colorMenuItem.monochrome + '-' + (900 - (index * 100)))"></div>
						</td>
					</tr>

					<tr>
						<td v-for="(color, color_index) in colorMenuItem.colors" :key="color_index" style="padding: 0px 2px 6px 0px;">
							<div :style="'background-color: var(--' + color + '-500)'" @click="selectColor('--' + color + '-500')"></div>
						</td>
					</tr>

					<tr v-for="(index) in colorMenuItem.colors.length" :key="index">
						<td v-for="(color, color_index) in  colorMenuItem.colors" :key="color_index" style="padding: 0px 2px 2px 0px;">
							<div :style="'background-color: var(--' + color + '-' + (900 - (index * 100)) + ')'" @click="selectColor('--' + color + '-' + (900 - (index * 100)))">&nbsp;</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</OverlayPanel>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	
	export default defineComponent({
		emits: ['update-color-event'],
		data(){
			return {
				colorMenuItem: {
					monochrome: 'surface',
					colors: [ 'red', 'orange', 'yellow', 'green', 'cyan', 'blue', 'indigo', 'purple']
				},
			}
		},
		props:{
			options:{
				type: Object,
				required: true
			},
			selectedOptions:{
				type: Object,
				required: false
			}
		},
		computed:{
			selectedColor(){
				if (this.selectedOptions != null) {
					return {'color': this.selectedOptions.value}
				}
	
				else{
					return {'color': this.options.value};
				}
			},
			colorOptions() {
				return this.options;
			}
		},
		methods:{
			selectColor(colorCode: any) {
				(this.$refs as any).colorMenu.hide();
				this.$emit('update-color-event', 'var('+colorCode+')');
			},
			toggleColorPicker(event: any) {
				(this.$refs as any).colorMenu.toggle(event);
			}
		}
	})
</script>